import store from "../../src/store";
import { DetectWC } from "../mixins/wcDetector";
import { DetectVersion } from "../mixins/versionDetector";
import { getStoreWithName } from "./services/storeService";
var isWC = DetectWC.methods.isWC();

export async function routerGuard(to, from, next) {
  // verify version
  var currentVersion = localStorage.getItem("VERSION");
  var appVersion = DetectVersion.methods.VERSION();
  if (currentVersion != appVersion) {
    store.dispatch("clearCart");
    localStorage.setItem("VERSION", appVersion);
  }
  if (to.fullPath.indexOf("giftcard") != -1) store.commit("setIsGift", true);
  else store.commit("setIsGift", false);
  if (to.query.room) {
    localStorage.setItem("room", to.query.room);
  }
  if (to.query.table) {
    localStorage.setItem("table", to.query.table);
  }
  if (to.query.coupon) {
    localStorage.setItem("coupon", to.query.coupon);
  }
  //detect refresh
  if (to.params.storename && !to.params.storeid) {
    if (isNumeric(to.params.storename)) to.params.storeid = to.params.storename;
    else if (from.params.storename == to.params.storename) {
      if (from.params.storeid) to.params.storeid = from.params.storeid;
      else to.params.storeid = store.getters.currentstore.ID;
    } else {
      var storeDoc = await getStoreWithName(
        to.params.storename.split("-").join(" ")
      ).get();
      if (storeDoc.size > 0) {
        to.params.storeid = storeDoc.docs[0].data().ID;
        store.dispatch("initStore", storeDoc.docs[0].data().ID);
      } else {
        next({
          name: "mainpage"
        });
      }
    }
  }
  if (to.params.storeid) {
    window.onload = function() {
      if (to.params.storeid) {
        store.dispatch("initStore", to.params.storeid);
      }
    };
  }
  //prevent intro page for none hq stores
  if (isWC) {
    var ooConfig = JSON.parse(sessionStorage.getItem("OOConfig"));
    if (ooConfig) {
      if (ooConfig.IsGift) {
        if (to.name == "mainpage") {
          next({
            name: "giftstore",
            params: {
              storeid: ooConfig.ID,
              storename: ooConfig.Name.split(" ").join("-")
            }
          });
          return false;
        }
      }
      if (ooConfig.IsHQ == false) {
        if (to.name == "mainpage") {
          next({
            name: "store",
            params: {
              storeid: ooConfig.ID,
              storename: ooConfig.Name.split(" ").join("-")
            }
          });
          return false;
        }
        //lock specefied store
        if (to.params.storeid) {
          if (to.params.storeid != ooConfig.ID) {
            var prms = to.params;
            prms.storeid = ooConfig.ID;
            next({ name: to.name, params: prms });
            return false;
          }
        }
      } else {
        storeChange(to, from, next);
      }
    }
  }
  storeChange(to, from, next);
}
function storeChange(to, from, next) {
  if (to.params.storeid) {
    store.dispatch("initPriceTriggers", to.params.storeid);
    store.dispatch("initMessageTemplates", to.params.storeid);
  }

  if (to.params.storeid && store.getters.currentstore) {
    if (
      to.params.storeid != store.getters.currentstore &&
      store.getters.cartItems.length > 0
    ) {
      let ok = confirm(
        "Switching store will clear items in your cart, would you like to proceed?"
      );
      if (ok) {
        store.dispatch("clearCart");
        next();
      } else {
        //next(false);
      }
    } else {
      next();
    }
  } else {
    next();
  }
}
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
